import Link from 'next/link';
import { useState, useEffect, useRef } from 'react';
import { strapi_end_point } from '../config';
import SubCategory from './SubCategory';
import { Link as LinkScroll } from 'react-scroll';
const qs = require('qs');
import { padhaai_url } from '../config';
import Lottie from 'lottie-react';
import PadhaaiImage from '../images/home/padhaai-img.png';
import animationData from '../lotties/sliderlottie.json';
import { useRouter } from 'next/router';
const HomeTab = () => {
	const router = useRouter();
	const [openTab, setOpenTab] = useState(0);
	const [data, setData] = useState([]);
	const [isLoading, setLoading] = useState(true);
	const [scrollY, setScrollY] = useState(0);
	const innerNav = useRef(null);
	const [q, setQuery] = useState('');
	useEffect(() => {
		setLoading(true);
		const obj = {
			sort: ['sorting:asc'],
			fields: ['id', 'name', 'slug'],
			populate: {
				subcat_id: {
					filters: {
						status: true,
					},
					sort: ['sorting:asc'],
					fields: ['id', 'name', 'slug'],
					populate: {
						topic_id: {
							fields: ['id', 'name', 'slug'],

							populate: {
								parent_id: {
									fields: ['id', 'name', 'slug'],
								},
								course_id: {
									fields: ['id'],
								}
							},
						},
						logo: '*',
					},
				},
			},
			pagination: {
				pageSize: 12,
				page: 1,
			},
			publicationState: 'live',
			locale: ['en'],
		};
		const query = qs.stringify(obj, {
			encodeValuesOnly: true, // prettify url
		});
		fetch(`${strapi_end_point}/api/padhaai-categories?${query}`)
			.then((res) => res.json())
			.then((data) => {
				// if (q.length > 0) {
				// 	for (var i = 0; i <= data.data.length; i++) {
				// 		if (data.data[i] != null) {
				// 			if (data.data[i].attributes.subcat_id.data != null) {
				// 				for (var j = 0; j <= data.data[i].attributes.subcat_id.data.length; j++) {
				// 					if (data.data[i].attributes.subcat_id.data[j] != null) {
				// 						if (data.data[i].attributes.subcat_id.data[j].attributes.name.indexOf(q) == -1) {
				// 							delete data.data[i].attributes.subcat_id.data[j];
				// 						}
				// 					}
				// 				}
				// 			}
				// 		}
				// 	}
				// }
				setData(Array.from(data.data));
				if (router.query.tab) {
					setTimeout(() => {
						document.getElementById(`link_id${router.query.tab}`).click();
					}, 500)
				} else {
					setOpenTab(data.data[0].id);

				}
				setLoading(false);
			});
	}, [router.isReady, router.query.tab]);
	useEffect(() => {
		const handleScroll = () => {
			setScrollY(window.scrollY);
		};
		handleScroll();
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return !isLoading ? (
		<>
			<section className="sm:py-[0] md:pt-[50px] sm:pt-[80px] pt-[30px]">
				<div className="innerDiv mx-auto">
					<div className="flex mb-4 lg:items-center lg:justify-between lg:flex-nowrap flex-wrap">
						<div className="lg:w-3/5 w-full px-3 lg:mb-0 sm:mb-9 mb-3">
							<h2 className="text-black sm:text-left text-center lg:text-[70px] sm:text-4xl text-2xl lg:leading-tight font-semibold sm:mb-9">Choose Your Padhaai</h2>
							<label className="relative sm:block hidden lg:w-3/4">
								<input
									className="placeholder:text-[#979797]  block border bg-white w-full sm:text-base text-xs rounded-lg sm:py-5 py-4 pl-3 pr-3 shadow-input focus:outline-none focus:border-primary focus:ring-themeColor"
									placeholder="Search from 5000+ free courses...."
									type="text"
									name="search"
									value={q}
									onChange={(e) => {
										setQuery(e.target.value);
									}}
									onKeyPress={(e) => e.key === 'Enter' && router.push('/courses?q=' + e.target.value)}
								/>
								<span onClick={() => {
									if (q.length > 0) {
										router.push('/courses?q=' + q)
									}

								}} className="absolute text-center inset-y-0 right-2 sm:top-[10px] top-[6px] sm:w-12 w-10 sm:h-12 h-10 flex items-center justify-center bg-themeColor rounded-lg cursor-pointer">
									<i className="far fa-search sm:text-2xl text-xl"></i>
								</span>
							</label>
						</div>
						<div className="lg:w-2/5 px-3 w-full lg:text-right block lg:mx-4">
							{/* <Image src={PadhaaiImage} alt='' width={400} height={383} /> */}
							<Lottie animationData={animationData} loop autoPlay />
							<label className="relative sm:hidden block lg:w-3/4 mt-[-50px]">
								<input
									className="placeholder:text-[#979797]  block border bg-white w-full sm:text-base text-xs rounded-lg sm:py-5 py-4 pl-3 pr-3 shadow-input focus:outline-none focus:border-primary focus:ring-themeColor"
									placeholder="Search from 5000+ free courses...."
									type="text"
									name="search"
									value={q}
									onChange={(e) => {
										setQuery(e.target.value);
									}}
									onKeyPress={(e) => e.key === 'Enter' && router.push('/courses?q=' + e.target.value)}
								/>
								<span onClick={() => {
									if (q.length > 0) {
										router.push('/courses?q=' + q)
									}

								}} className="absolute text-center inset-y-0 right-2 sm:top-[10px] top-[6px] sm:w-12 w-10 sm:h-12 h-10 flex items-center justify-center bg-themeColor rounded-lg cursor-pointer">
									<i className="far fa-search sm:text-2xl text-xl"></i>
								</span>
							</label>
						</div>
					</div>
				</div>
			</section>
			<section className="pb-[50px] sm:pt-[80px] sm:pb-[80px] lg:pt-[10px] lg:pb-[100px] home-container relative">

				<div className="innerDiv mx-auto">
					{/* <div className="flex sm:justify-end mb-6">
						<select id="country" name="country" className="w-36 block appearance-none py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-500 focus:border-gray-500">
							<option>My Goals</option>
							<option>My Goals</option>
							<option>My Goals</option>
						</select>
					</div> */}
					<div className="tabs relative">
					<div className="blur-homeTab pointer-events-none"></div>
						<ul
							className={
								scrollY > 450
									? 'whitespace-nowrap sm:mt-0 mt-[30px] sm:overflow-hidden overflow-x-scroll custom-x-scroll sticky sm:top-[75px] top-[54px] bg-white z-40 home-topheader'
									: 'whitespace-nowrap sm:mt-0 mt-[30px] sm:overflow-hidden overflow-x-scroll custom-x-scroll sticky sm:top-[75px] top-[54px] bg-white z-40'
							}>
							{!isLoading &&
								data.map((category, index) => {
									return (
										<li key={index} className="inline-block mr-4 last:mr-7">
											<a
												className={openTab === category.id ? 'text-themeColor active border-x border-t border-b-white border-b bg-white py-3 px-6 block rounded-t-md font-medium' : 'text-black bg-white py-3 px-6 block rounded-t-md font-medium'}
												onClick={(e) => {
													e.preventDefault();
													setOpenTab(category.id);
												}}
												data-toggle="tab"
												href={`#link${category.id}`}
												role="tablist"
												id={`link_id${category.id}`}>
												{category.attributes.name}
											</a>
										</li>
									);
								})}
						</ul>
						<div className="flex flex-wrap -mx-2">
							<div className="lg:w-5/6 px-2 w-full">
								<div className="tab-content border sm:p-6 p-3">
									{!isLoading &&
										data.map((category, index) => {
											return (
												<div key={index} className={openTab === category.id ? 'course block' : 'hidden'} id={`link${category.id}`}>
													{category.attributes.subcat_id.data !== null &&
														category.attributes.subcat_id.data.map((subcategory, index) => {
															return <SubCategory key={index} subcategory={subcategory} />;
														})}
												</div>
											);
										})}
								</div>
							</div>
							{!isLoading &&
								data.map((category, index) => {
									return (
										<div key={index} className={`lg:w-2/12 w-full px-2 ${openTab === category.id ? 'lg:block hidden' : 'hidden'}`}>
											<div className="bg-[#FAFAFA] p-6 sm:mb-0 mb-6 sticky top-[120px]">
												<ul className="list-disc pl-3 font-medium" ref={innerNav}>
													{category.attributes.subcat_id.data !== null &&
														category.attributes.subcat_id.data.map((subcategory, index) => {
															return (
																<li key={index} className={`${index == 0 ? `` : ``}`}>
																	<LinkScroll to={subcategory.attributes.name} offset={-180} duration={500} spy={true}>
																		<Link href={`${padhaai_url}/padhaai-gurucool/subcategory/${subcategory.attributes.slug}`}>
																			<a>{subcategory.attributes.name}</a>
																		</Link>
																	</LinkScroll>
																</li>
															);
														})}
												</ul>
											</div>
										</div>
									);
								})}
						</div>
					</div>
				</div>
			</section>
		</>
) : (
	<center>
		<a className="play-btn  h-screen flex justify-center items-center absolute inset-0 z-[999] bg-[rgba(0,0,0,1)]" id="pre-loader">
			<svg width="404" height="411" viewBox="0 0 404 411" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path d="M7.99999 114.55C9.36999 114.36 5.79 102.47 12 92.08C15.4 86.37 20.49 83.22 25.76 80.62C48.97 69.13 74.06 68.39 74.06 68.39C98.3473 67.6797 122.649 69.1624 146.67 72.82C173.286 76.8737 199.482 83.3198 224.94 92.08C244.597 99.3128 263.534 108.372 281.5 119.14C287.688 122.926 293.475 127.332 298.77 132.29C303.7 136.89 307.31 140.29 310.55 145.89C312.61 149.48 317.38 157.78 316.35 168.52C315.45 177.98 310.52 184.33 306.42 189.61C300.99 196.61 295.72 200.35 287.42 206.12C273.218 216.121 257.607 223.953 241.1 229.36C235.45 231.17 230.93 232.3 227.19 233.18C213.72 236.36 187.67 241.73 144.65 246.48C144.15 242.48 143.44 236.48 142.65 229.2C141.18 215.58 140.41 206.36 140.05 202.45C138.56 187.359 136.007 172.392 132.41 157.66C131.669 154.486 130.697 151.371 129.5 148.34C126.92 141.8 125.23 140.62 124.15 140.08C122.63 139.349 120.913 139.134 119.26 139.47C117.126 140.081 115.281 141.436 114.06 143.29C107.7 151.97 99.33 159.01 92.66 167.45C84.91 177.25 85.51 175.73 74.93 189C69.71 195.55 67.03 198.92 63.46 203.83C52.66 218.69 50 225.19 49.09 227.52C46.64 233.86 45.49 237.77 45.27 241.74C44.9258 245.614 45.3959 249.518 46.65 253.2C49.09 260.02 53.93 263.89 56.89 266.2C62.5 270.57 68.52 272.9 77.22 274.91C89.3474 277.681 101.792 278.811 114.22 278.27C114.01 283.56 113.82 290.19 113.77 297.84C113.77 302.58 113.71 312.84 114.22 326.27C114.65 337.43 114.94 345.15 116.06 355.78C117.187 365.956 119.13 376.025 121.87 385.89C123.274 391.284 125.773 396.332 129.21 400.72C131.271 403.476 133.936 405.723 137 407.29C139.158 408.356 141.487 409.033 143.88 409.29C147.546 409.641 151.239 409.01 154.58 407.46C152.79 392.73 151.71 380.77 151.07 372.91C150.01 360.02 149.47 349.76 147.7 308.91C147.14 295.77 146.7 284.68 146.33 276.5C152.7 275.89 161.77 274.93 172.62 273.44C199.53 269.76 219.7 265.28 235.75 261.67C257.51 256.79 274.69 252.1 286.05 248.83C298.24 245.32 304.34 243.57 310.81 241.19C324.71 236.08 342.35 229.59 360.03 215.35C370.346 207.375 379.239 197.712 386.33 186.77C392.11 177.77 400.33 164.94 401.92 146.56C404.5 117.37 388.59 95.96 384.49 90.61C379.36 83.92 374.65 80.04 365.23 72.27C350.442 60.1199 334.342 49.6616 317.23 41.09C290.63 27.65 268.71 21.92 248.44 16.63C231.835 12.2825 214.994 8.89353 198 6.48C181.9 4.2 162.82 1.58 137.46 2.2C121.979 2.59982 106.548 4.13056 91.29 6.78C76.57 9.33 66.69 11.11 54 16.26C42.85 20.79 31 25.73 20.06 37.36C12.7328 44.7249 7.28011 53.7407 4.16 63.65C0.849999 74.56 1.50999 83.52 2.01999 90.55C2.99999 103.9 6.70999 114.74 7.99999 114.55Z" stroke="#f9c933" strokeWidth="4" strokeMiterlimit="10" />
				<path d="M117.85 172.57C117.85 174.57 117.85 177.57 117.85 181.28C117.72 195.64 117.01 206.19 116.7 211.09C116.16 219.75 115.55 232.4 115.32 249.15C112.41 249.37 108.23 249.62 103.17 249.73C101.53 249.73 94.76 249.89 85.75 249.38C79.69 249.04 76.24 248.61 72.22 247.43C70.6631 246.977 69.131 246.443 67.63 245.83C68.81 242.78 70.63 238.48 73.02 233.45C77.6791 224.025 83.1251 215.009 89.3 206.5C90.97 204.1 96.23 196.66 102.94 188.73C107.19 183.73 109.31 181.22 111.2 179.56C112.981 178.011 114.651 176.341 116.2 174.56C116.94 173.71 117.49 173 117.85 172.57Z" stroke="#f9c933" strokeWidth="4" strokmiterlimit="10" />
			</svg>
		</a>

	</center>
);
};
export default HomeTab;
